import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { authFetch } from '../utils/api';
import { Mail, X } from 'lucide-react';

const TXT = {
  en: {
    msg: 'Please verify your email address to unlock all features.',
    resend: 'Resend email',
    sent: 'Verification email sent.',
    dismiss: 'Dismiss',
  },
  el: {
    msg: 'Παρακαλώ επαληθεύστε το email σας για να ξεκλειδώσετε όλες τις λειτουργίες.',
    resend: 'Νέα αποστολή',
    sent: 'Το email επαλήθευσης στάλθηκε.',
    dismiss: 'Απόκρυψη',
  }
};

const EmailVerificationBanner = () => {
  const { user } = useAuth();
  const { language } = useLanguage();
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('email-banner-dismissed') === '1');

  if (!user || !user.id || user.email_verified || dismissed) return null;
  const T = TXT[language] || TXT.en;

  const handleResend = async () => {
    setBusy(true);
    try {
      await authFetch('/api/auth/resend-verification', {
        method: 'POST',
        body: JSON.stringify({ email: user.email }),
      });
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  const handleDismiss = () => {
    sessionStorage.setItem('email-banner-dismissed', '1');
    setDismissed(true);
  };

  return (
    <div
      data-testid="email-verification-banner"
      className="bg-gradient-to-r from-amber-500/20 via-yellow-500/15 to-amber-500/20 border-b border-amber-500/30 text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-2 text-sm">
          <Mail size={16} className="text-amber-300 flex-shrink-0" />
          <span>{sent ? T.sent : T.msg}</span>
        </div>
        <div className="flex items-center gap-3">
          {!sent && (
            <button
              data-testid="email-banner-resend"
              onClick={handleResend}
              disabled={busy}
              className="text-sm font-semibold underline-offset-2 hover:underline disabled:opacity-60"
            >
              {busy ? '...' : T.resend}
            </button>
          )}
          <button
            data-testid="email-banner-dismiss"
            onClick={handleDismiss}
            aria-label={T.dismiss}
            className="text-white/60 hover:text-white transition-colors"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
